import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignalIcon } from '@heroicons/react/24/outline'; // 添加Wifi图标
import { verifypwd, createHole } from '../services/api';
import Footer from '../components/Footer';
import { AxiosError } from 'axios';

const Home: React.FC = () => {
  const [pwd, setpwd] = useState({ x: '', y: '', z: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // 页面加载完成后将焦点移到 inputX
    const inputX = document.getElementById('inputX');
    inputX?.focus();
  }, []);

  // 验证口令格式
  const validatepwd = (part: string): boolean => {
    // 允许0-6个字符，可以是英文字母、数字、下划线或中文
    const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_]{0,6}$/;
    return regex.test(part);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const fullpwd = `${pwd.x}.${pwd.y}.${pwd.z}`;
    if(fullpwd==='..') return ;

    // 验证每个部分的格式
    if (!validatepwd(pwd.x) || !validatepwd(pwd.y) || !validatepwd(pwd.z)) {
      setError('口令格式不正确');
      return;
    }

    try {
      setLoading(true);
      const response = await verifypwd(fullpwd);
      if (response.id) {
        navigate(`/hole/${response.id}`);
        setLoading(false);
        return;

      }
    } catch (e) {
      const err = e as AxiosError;
      if (err.isAxiosError && err.status === 404) {
        // 如果口令不存在，则创建新的虫洞
        try {
          const createResponse = await createHole(fullpwd, fullpwd);
          navigate(`/hole/${createResponse.hole_id}`);
        } catch (createErr) {
          console.error(createErr);
          setError('能量不足，创建树洞失败，请稍后再试！');
        }
      } else {
        console.error(e)
        setError("信息树没有响应！");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, part: 'x' | 'y' | 'z') => {
    const inputs = [document.getElementById('inputX'), document.getElementById('inputY'), document.getElementById('inputZ')];
    const idxs = { 'x': 0, 'y': 1, 'z': 2 };
    switch (e.key) {
      case 'Backspace':
        const currentValue = pwd[part];
        console.log(currentValue);
        if (currentValue.length === 0)
          inputs[idxs[part] - 1]?.focus();

        break;
      case '.':
        e.preventDefault(); // 阻止输入小数点
        //const currentValue = pwd[part];

        inputs[idxs[part] + 1]?.focus();

        break;

      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault(); // 阻止默认行为
        inputs[idxs[part] + 1]?.focus(); // 移动焦点到下一个输入框
        break;

      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault(); // 阻止默认行为
        inputs[idxs[part] - 1]?.focus(); // 移动焦点到下一个输入框
        break;
    }
  };

  const handleInputChange = (part: 'x' | 'y' | 'z', value: string) => {
    /*
    const inputs = [document.getElementById('inputY'), document.getElementById('inputZ')];
    const l = value.length;
    if (value[l - 1] === '.') {
      value = value.substring(0, l - 1);
      // 移动焦点到下一个输入框
      if (part === 'x') {
        inputs[0]?.focus();
      } else if (part === 'y') {
        inputs[1]?.focus();
      }
    }
    */
    //console.log(value);

    if (validatepwd(value)) {
      setpwd(prev => ({ ...prev, [part]: value }));
      setError('');
    }
  };



  return (
    <div className="min-h-screen bg-gray-500 flex flex-col">

      <header className="w-full bg-white/90 backdrop-blur-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img src="/logo.png" alt="口令树洞" className="h-8 w-8" />
            <span className="text-l font-bold text-primary leading-tight">口令树洞<br />kouling.xyz</span>
          </div>
          <div className="text-center">一个口令，传送信息</div>
        </div>
      </header>

      {/* 主要内容 */}
      <main className="flex-1 flex items-center justify-center p-4 bg-white/90 relative">
        {/* 背景图片 */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="relative bg-cover bg-center rounded-lg shadow-xl"
            style={{ backgroundImage: 'url(/background.jpg)', width: '100%', height: '100%', maxWidth: '900px', maxHeight: '660px' }}
          >
            <div className="absolute text-white text-l" style={{ textShadow: '3px 3px 3px rgba(0, 0, 0, 1)', top: '5%', right: '1rem', textAlign: 'right' }}>
              {/* 逐行显示的文本 */}
              <div className="line-container">
                <p className="line">传说在宇宙中心，</p>
                <p className="line">有一株神奇的信息树，</p>
                <p className="line">它无限小，像一个点；</p>
                <p className="line">它又无限大，充斥整个宇宙。</p>
                <p className="line">树上有近乎无限的树洞，</p>
                <p className="line">每个树洞都有一个唯一的口令。</p>
                <p className="line">任何时间，任何地点、任何人，</p>
                <p className="line">通过引力波发送正确的口令，</p>
                <p className="line">就可以进入相应的树洞，</p>
                <p className="line">查阅和传送任何形式的信息。</p>
              </div>
            </div>

            {/* 口令输入区 */}
            <div className="absolute " style={{ bottom: '50px', right: '1rem' }}>
              <div className="bg-white/90 backdrop-blur-sm p-4 rounded-lg shadow-lg w-[320px]">
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <span className="text-3xl relative -top- z-10">🔑</span>请输入口令：
                    </label>
                    <div className="flex items-center space-x-2 justify-center">
                      <input
                        id="inputX"
                        type="text"
                        value={pwd.x}
                        onKeyUp={(e) => handleKeyDown(e, 'x')}
                        onChange={(e) => handleInputChange('x', e.target.value)}
                        className="w-20 px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-primary text-center"
                        placeholder="X"
                      />
                      <span className="text-gray-900 font-bold">.</span>
                      <input
                        id="inputY"
                        type="text"
                        value={pwd.y}
                        onKeyUp={(e) => handleKeyDown(e, 'y')}
                        onChange={(e) => handleInputChange('y', e.target.value)}
                        className="w-20 px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-primary text-center"
                        placeholder="Y"
                      />
                      <span className="text-gray-500 font-bold">.</span>
                      <input
                        id="inputZ"
                        type="text"
                        value={pwd.z}
                        onKeyUp={(e) => handleKeyDown(e, 'z')}
                        onChange={(e) => handleInputChange('z', e.target.value)}
                        className="w-20 px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-primary text-center"
                        placeholder="Z"
                      />
                    </div>
                    <p className="text-center text-xxs text-gray-500 mt-1">
                      X,Y,Z分别由0~6个英文、数字、下划线或中文字符组成
                    </p>
                    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-1 bg-primary text-white rounded hover:bg-opacity-90 transition-colors"
                  >
                    <span className="flex items-center justify-center">
                      <SignalIcon className="w-7 h-7 ml-1" />
                      {loading ? '发送中...' : '发送'}
                      {(pwd.x || pwd.y || pwd.z) && <span className="text-gray-100 text-xs px-3">{pwd.x + '.' + pwd.y + '.' + pwd.z}</span>}
                    </span>
                  </button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Home; 